import { Box } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

import { getCountriesAndStatesOptions } from "@/utils/forms/getCountriesAndStatesOptions";
import { useGetCountriesAndStatesQuery } from "@/redux-store/api/marketingApi";

import { FormTitle } from "../components";
import Field from "@/components/RHFcomponents/Field";
import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import PhoneInput from "@/components/RHFcomponents/PhoneInput";

interface IProp {
  methods: UseFormReturn<IFleetInquiryForm, unknown, undefined>;
}

const FormFirstStep: React.FC<IProp> = ({ methods: { control, watch } }) => {
  // Get drop down menu options
  const { data } = useGetCountriesAndStatesQuery({});
  const { countryOptions, stateOptions } = getCountriesAndStatesOptions(data);

  const isUSAselected = watch().idCountry === 1; // If USA as country is selected, show states drop down
  const gap = { xs: 2, md: 3 }; // Styles

  return (
    <>
      <FormTitle
        title="Provide your contact information"
        subtitle="We'll use this information to get in touch regarding your fleet inquiry."
        withHeader
      />
      <Box display="flex" gap={gap} flexDirection="column">
        <Box display="flex" justifyContent="space-between" gap={gap}>
          <Field
            name="firstName"
            control={control}
            placeholder="Your first name"
          />
          <Field
            name="lastName"
            control={control}
            placeholder="Your last name"
          />
        </Box>

        <Box display="flex" justifyContent="space-between" gap={gap}>
          <Field name="email" control={control} placeholder="Your email" />
          <Field
            name="fleetUsageCompanyName"
            control={control}
            placeholder="Company name"
          />
        </Box>

        <Field
          name="address"
          control={control}
          placeholder="Your street name and number"
        />

        <Box display="flex" justifyContent="space-between" gap={gap}>
          <Field name="city" control={control} placeholder="Your city / town" />
          <Field name="zipCode" control={control} placeholder="Your ZIP code" />
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          gap={gap}
          sx={{
            "& .MuiFormControl-root:last-of-type": {
              display: isUSAselected ? "block" : "none",
            },
          }}
        >
          {countryOptions.length > 0 && (
            <DropdownInput
              name="idCountry"
              control={control}
              options={countryOptions}
              placeholder="Your country"
            />
          )}
          {stateOptions.length > 0 && (
            <DropdownInput
              name="idState"
              placeholder="Your State"
              control={control}
              options={stateOptions}
            />
          )}
        </Box>
        <PhoneInput
          name="phoneNumber"
          control={control}
          placeholder="Your phone"
        />
      </Box>
    </>
  );
};

export default FormFirstStep;
